import Vue from 'vue/dist/vue'; //引入 umd 文件
window.Vue = Vue; //写入window对象